exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".badge-9-wrapper[data-v-164e5bf0]{width:235px;padding-bottom:10px}.listing-img[data-v-164e5bf0]{width:24px;height:24px;border-radius:50%}", ""]);

// exports
